module.exports = __webpack_public_path__ + "img/marksandspencer.1a0d2cdf.jpg";